import {
    useCallback,
} from 'react'
import noop from 'lodash/noop'
import SimpleTable, {
    RowComponent,
} from 'app/shared-components/SimpleTable'
import ConfirmationDialog from 'app/shared-components/ConfirmationDialog'
import WarningCard from 'app/shared-components/WarningCard'
import {
    Column,
} from 'app/types/simpletable.types'
import {
    WarningCardVariant,
} from 'app/enums/common.enums'

import useStyles from './DuplicationCheckDialog.styles'

const defaultProps = {
    title: 'Creation Confirmation',
    positiveLabel: 'Create anyway',
    data: null,
    dialogClassName: undefined,
}

type DuplicationCheckDialogProps<D> = Readonly<{
    data?: D[],
    columns: Column<keyof D>[],
    close: () => void,
    create: (...args: any[]) => void,
    message: string,
    title?: string,
    positiveLabel?: string,
    dialogClassName?: string,

}>

function DuplicationCheckDialog<D>({
    columns,
    data,
    create,
    close,
    message,
    title,
    positiveLabel,
    dialogClassName,
}: DuplicationCheckDialogProps<D>) {
    const {
        classes,
    } = useStyles()
    const open = Boolean(data?.length)

    const handleClose = useCallback((positive) => {
        if (positive) {
            create()
            close()
            return
        }

        close()
    }, [
        create,
        close,
    ])

    return (
        <ConfirmationDialog
            open={open}
            handleClose={handleClose}
            dialogTitle={title}
            positiveLabel={positiveLabel}
            negativeLabel="Cancel"
            classNames={{
                paper: dialogClassName || classes.paper,
            }}
        >
            {open ? (
                <>
                    <WarningCard variant={WarningCardVariant.Critical}>
                        {message}
                    </WarningCard>

                    <SimpleTable
                        component={RowComponent}
                        onChange={noop}
                        columns={columns}
                        data={data}
                        classNames={classes}
                        disabled
                    />
                </>

            ) : null}
        </ConfirmationDialog>
    )
}

DuplicationCheckDialog.defaultProps = defaultProps

export default DuplicationCheckDialog
